export const whitelistQueryParamsHash = {
  email: 'email',
  referral: 'referral',
};

export const whitelistQueryParamsSearch = {
  // Appsflyer params - DEPRECATED
  af_ad_id: 'af_ad_id',
  af_adset: 'af_adset',
  af_c_id: 'af_c_id',
  af_channel: 'af_channel',
  af_click_lookback: 'af_click_lookback',
  af_sub1: 'af_sub1',
  af_sub2: 'af_sub2',
  af_sub3: 'af_sub3',
  af_sub4: 'af_sub4',
  c: 'c',
  pid: 'pid',

  // Singular params - https://support.singular.net/hc/en-us/articles/360018879491-Tracking-Link-Parameters
  ip: 'ip',
  cl: 'cl',
  ve: 've',
  idfa: 'idfa',
  ifa1: 'ifa1',
  ifa5: 'ifa5',
  idfv: 'idfv',
  ifv1: 'ifv1',
  ifv5: 'ifv5',
  aifa: 'aifa',
  aif1: 'aif1',
  aif5: 'aif5',
  andi: 'andi',
  and1: 'and1',
  and5: 'and5',
  oaid: 'oaid',
  amid: 'amid',
  sng_ref: 'sng_ref',
  ua: 'ua',
  lc: 'lc',
  pssn: 'pssn',
  pssid: 'pssid',
  p: 'p',
  pcn: 'pcn',
  pcid: 'pcid',
  pscn: 'pscn',
  pscid: 'pscid',
  pcrn: 'pcrn',
  pcrid: 'pcrid',
  pshid: 'pshid',
  psn: 'psn',
  psid: 'psid',
  kw: 'kw',
  paffn: 'paffn',
  paffid: 'paffid',
  _dl: '_dl',
  _ddl: '_ddl',
  _global_redirect: '_global_redirect',
  _fallback_redirect: '_fallback_redirect',
  _android_dl: '_android_dl',
  _android_ddl: '_android_ddl',
  _ios_dl: '_ios_dl',
  _ios_ddl: '_ios_ddl',
  _p: '_p',
  _force_redirect: '_force_redirect',
  redirect: 'redirect',
  _forward_params: '_forward_params',
  an: 'an',
  wpcid: 'wpcid',
  wpcn: 'wpcn',
  wpcrid: 'wpcrid',
  wpcrn: 'wpcrn',
  wpkmatch: 'wpkmatch',
  wpkwid: 'wpkwid',
  wpkwn: 'wpkwn',
  wpscid: 'wpscid',
  wpscn: 'wpscn',
  wpsn: 'wpsn',
  wpsrc: 'wpsrc',

  // Other
  adset_id: 'adset_id',
  anonymous_id: 'anonymous_id',
  campaign_id: 'campaign_id',
  clickid: 'clickid',
  deep_link_value: 'deep_link_value',
  GBRAID: 'GBRAID',
  gclid: 'gclid',
  intent: 'intent',
  irclickid: 'irclickid',
  irgwc: 'irgwc',
  ranEAID: 'ranEAID',
  ranMID: 'ranMID',
  ranSiteID: 'ranSiteID',
  rclid: 'rclid',
  rdt_cid: 'rdt_cid',
  shortlink: 'shortlink',
  ttclid: 'ttclid',
  utm_ad_id: 'utm_ad_id',
  utm_adset_id: 'utm_adset_id',
  utm_ad_name: 'utm_ad_name',
  utm_adset_name: 'utm_adset_name',
  utm_campaign: 'utm_campaign',
  utm_content: 'utm_content',
  utm_medium: 'utm_medium',
  utm_source: 'utm_source',
  utm_term: 'utm_term',
  WBRAID: 'WBRAID',
  web_content_type: 'web_content_type',
  web_page_name: 'web_page_name',
};

export const whitelistQueryParams = {
  hash: whitelistQueryParamsHash,
  search: whitelistQueryParamsSearch,
};
